import { useBrightSaaSStarField } from '../hooks/useBrightSaaSStarField';
import founderPhoto from 'src/assets/images/img_1243.jpg';

export function AboutPage() {
  useBrightSaaSStarField();
  return (
    <>
      <header className="nk-header" id="home">
        <div className="section section-lg section-b-0">
          <div className="section-heading">
            <div className="container">
              <div className="row justify-content-between align-items-center">
                <div className="col-lg-6 col-xl-5">
                  <div className="text-block">
                    <div className="fs-9 text-uppercase text-gradient-a w-max mb-4">
                      About Company
                    </div>
                    <h2 className="title text-gradient-heading fw-medium fs-1 mb-4">
                      We turn marketing data into decisions you can trust
                    </h2>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="gfx me-xl-6 mt-xl-n4">
                    <img src="/marketing/landing/map-a.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <main className="nk-main">
        <div className="section section-xl section-t-0">
          <div className="section-content">
            <div className="container">
              <div className="row g-gs justify-content-between align-items-stretch">
                <div className="col-lg-6">
                  <div className="card card-bordered bg-background h-100 overflow-hidden">
                    <div className="card-body">
                      <h5 className="fs-7 mb-3">
                        From scattered data to decisions that stick
                      </h5>
                      <p className="fs-8 mb-3">
                        Marketing data sits across dashboards, exports, and
                        inboxes — and rarely in the form a decision needs. By
                        the time the picture is assembled, the moment to act has
                        usually passed.
                      </p>
                      <p className="fs-8 mb-3">
                        We built Yapamar to close that gap. It connects your
                        channels, models the real drivers of performance, and
                        surfaces the answers your team needs in the language a
                        decision is made in.
                      </p>
                      <p className="fs-8 mb-3">
                        The way analytics has been delivered to marketing teams
                        hasn&rsquo;t worked. Static reports, long modeling
                        cycles, and tools only specialists can read — we wanted
                        to build something a working team can actually use, end
                        to end.
                      </p>
                      <p className="fs-8 mb-0">
                        What we&rsquo;re aiming at is straightforward: a tool
                        that pays for itself in better decisions, not in saved
                        reporting hours. If a team using Yapamar spends its
                        budget a little more wisely each quarter, we&rsquo;ve
                        done our job.
                      </p>
                    </div>
                    <div className="card-gfx mx-n4 mt-n4">
                      <img src="/marketing/landing/mission.png" alt="" />
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="card card-bordered bg-background h-100 overflow-hidden">
                    <div className="card-body">
                      <h5 className="fs-7 mb-3">
                        Rigorous where it matters, simple where it should be
                      </h5>
                      <p className="fs-8 mb-3">
                        We&rsquo;re a distributed team — analysts, data
                        scientists, engineers — and we share one bias: the
                        answer should be in the product, not in a slide deck a
                        consultant delivers six weeks later.
                      </p>
                      <p className="fs-8 mb-3">
                        That bias shapes how we build. The model has to be
                        defensible, the chart has to be readable without a
                        footnote, and the workflow has to fit into the way a
                        marketing team already works. If any one of those
                        breaks, the product isn&rsquo;t doing its job.
                      </p>
                      <p className="fs-8 mb-3">
                        It matters because the alternative is expensive. A
                        marketing decision made on the wrong picture
                        doesn&rsquo;t just waste the budget — it sends the next
                        quarter chasing a pattern that was never really there.
                      </p>
                      <p className="fs-8 mb-0">
                        The whole pipeline — ingestion, modeling, attribution,
                        recommendation — is meant to disappear into the
                        background. Your team should be debating what to do with
                        the answer, not whether to trust it.
                      </p>
                    </div>
                    <div className="card-gfx mx-n4 mt-n4">
                      <img src="/marketing/landing/vision.png" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/*<div className="gradient-separator"></div>
        <div className="section section-xl has-mask">
          <div className="bg-pattern-dot pattern-dot-gap-3xs blend-around-large bg-mask bg-mask-middle h-600px mx-auto mw-100rem w-100 bg-primary bg-opacity-30 opacity-40"></div>
          <div className="bg-mask nk-star-field" data-star-count="100"></div>
          <div className="section-content">
            <div className="container">
              <div className="row gy-sm-8 justify-content-between align-items-center">
                <div className="col-12 col-lg-4">
                  <div className=" bg-opacity-40 border-lighter h-100 overflow-hidden">
                    <div className=" text-center">
                      <div className="d-flex align-items-center justify-content-center has-mask mx-n5 mx-md-n9 mt-n4 mb-n2 py-7">
                        <div className="bg-mask mb-2 mx-5"></div>
                        <div
                          className="media media-circle z-1 has-mask"
                          style={{ ['--media-size' as string]: '18rem' }}>
                          <div className="bg-mask bg-primary opacity-40"></div>
                          <img
                            className="w-100 filter-saturate-0 mix-blend-overlay opacity-90"
                            src={founderPhoto}
                            alt=""
                          />
                          <div className="bg-mask border border-2 border-background border-opacity-30 rounded-pill"></div>
                        </div>
                      </div>
                      <h6 className="fs-7">Julia Vasilieva</h6>
                      <p className="fs-9 text-content mb-3">
                        Co-Founder &amp; COO
                      </p>
                      <ul className="d-flex justify-content-center gap-1 fs-6">
                        <li>
                          {' '}
                          <a
                            className="link-content styled-icon rounded-pill border-hover border-hover-light"
                            href="https://x.com/YapamarMMM"
                            target="_blank"
                            rel="noopener noreferrer">
                            <em className="icon ni ni-x"></em>
                          </a>{' '}
                        </li>
                        <li>
                          {' '}
                          <a
                            className="link-content styled-icon rounded-pill border-hover border-hover-light"
                            href="https://www.linkedin.com/in/yuliia-vasilieva"
                            target="_blank"
                            rel="noopener noreferrer">
                            <em className="icon ni ni-linkedin"></em>
                          </a>{' '}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-lg">
                  <div className="text-block">
                    <p className="fs-8 mb-6">
                      Before Yapamar, I spent five years inside marketing,
                      media, and analytics. From that seat, I watched smart
                      teams make consequential budget calls on numbers nobody
                      fully trusted, including their own.
                    </p>
                    <p className="fs-8 mb-6">
                      Yapamar is my attempt to build the tool I wished those
                      teams had: something that ends a budget meeting with a
                      decision, not a debate.
                    </p>
                    <p className="fs-8 mb-6">
                      The view comes from years close to the problem; the
                      product lives or dies on the team building it day to day.
                      We&rsquo;ve assembled the data scientists and engineers
                      needed to make the rigor stick — and to keep the product
                      moving faster than the problem changes.
                    </p>
                    <p className="fs-8 mb-6">
                      Yapamar isn&rsquo;t a dashboard you check once a week.
                      It&rsquo;s the layer your team plans, defends, and
                      reallocates against — the place a marketing decision
                      starts and ends.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        */}
      </main>
    </>
  );
}
